import Navbar from "./components/navbar";
import GallerySection from "./components/GallerySection";
import Footer from "./components/Footer";

function Gallery() {
  return (
    <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-black text-white min-h-screen overflow-hidden">
      {/* Navigation */}
      <Navbar galleryOnly />

      <GallerySection />

      <Footer />
    </div>
  );
}

export default Gallery;
